<template>
  <div>
    <div
      v-for="(poi, index) in this.itinerario.poi"
      :key="'poi' + (index + 200)"
    >
      <div
        v-for="(it, ind) in poi.activitiesInPOI"
        :key="'availableActivities' + (ind + 200)"
        class="row"
      >
        <div class="col-12">
          <div class="row" v-if="ind > 0">
            <div class="col-12 pl-4">
              <div class="vertical-line-same-poi ml-5"></div>
            </div>
          </div>
          <div
            v-if="
              poi.poiName !== 'Punto di partenza' &&
              poi.poiName !== 'Punto di arrivo'
            "
            class="row mr-1 mb-0 itinerary-card orange"
            style="border-radius: 10px"
          >
            <div
              class="col-3 text-center px-0"
              style="
                background-color: #4f9bff;
                border-top-left-radius: 10px;
                border-bottom-left-radius: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #ffffff;
              "
            >
              <img
                v-img="{
                  group: getGroupName(poi) + ind + 'large',
                }"
                v-if="
                  poi.media.length > 0 &&
                  ind === 0 &&
                  (it.activityType === undefined ||
                    it.activityType.includes('Pranzo') ||
                    it.activityType.includes('Parcheggio'))
                "
                :src="getSrc(poi)"
                :alt="poi.poiName"
                style="
                  height: 100%;
                  width: 100%;
                  border-top-left-radius: 10px;
                  border-bottom-left-radius: 10px;
                "
              />
              <img
                v-img="{
                  group: getGroupName(poi) + ind + 'large',
                }"
                v-else-if="it.media && it.media.length > 0"
                :src="it.media[0]['thumbnail_display_urls']['large']"
                style="
                  height: 100%;
                  width: 100%;
                  border-top-left-radius: 10px;
                  border-bottom-left-radius: 10px;
                "
                :alt="poi.poiName"
              />
              <!--nel v-if dell'immagine sopra c'era un ind > 0-->
              <img
                v-img="{
                  group: getGroupName(poi) + ind + 'large',
                }"
                v-else
                src="@/assets/images/default.png"
                :alt="poi.poiName"
                style="
                  height: 100%;
                  border-top-left-radius: 10px;
                  border-bottom-left-radius: 10px;
                "
              />
            </div>

            <div class="col-9 text-left py-2">
              <div class="row">
                <div class="col-12">
                  <b>{{ it["activityName"].toUpperCase() }} </b>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <i class="bi bi-pin-map-fill mr-2"></i>{{ poi["poiName"] }}
                </div>
              </div>

              <div class="row" v-if="index !== 1">
                <div class="col-12">
                  <i class="bi bi-clock mr-2"></i
                  >{{ it["serviceDurationMinutes"] }} minuti
                  <template v-if="it['setupTimeMinutes'] > 1"
                    >+ {{ it["setupTimeMinutes"] }} minuti di
                    organizzazione</template
                  >
                  <template v-else-if="it['setupTimeMinutes'] > 0"
                    >+ {{ it["setupTimeMinutes"] }} minuto di
                    organizzazione</template
                  >
                </div>
              </div>

              <div class="row" v-if="it['activityType'] !== 'Non disponibile'">
                <div class="col-12">
                  <i class="bi bi-info-circle mr-1"></i>
                  <template v-if="!it['activityName'].includes('Visita')">
                    {{ it["activityType"] }}
                  </template>
                  <template v-else> Visita del luogo </template>
                </div>
              </div>

              <div
                class="row"
                v-if="index !== 1 && !it['activityName'].includes('Pranzo')"
              >
                <Button
                  type="primary"
                  size="small"
                  v-on:click="
                    selectMarkerOnMap(poi['poiName'], it['activityName'])
                  "
                  class="m-2 button_font"
                  >Visualizza dettagli
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          poi.poiName !== 'Punto di partenza' &&
          poi.poiName !== 'Punto di arrivo' &&
          index < itinerario.poi.length - 2 &&
          checkPoiAndNextPoiAreDifferent(poi, itinerario.poi[index + 1])
        "
        class="row mb-0 pl-5"
      >
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <div class="vertical-line ml-2"></div>
            </div>
          </div>
          <div class="row mt-2 mb-1">
            <div class="col-12">
              <b
                ><i class="bi bi-clock mr-2"></i>
                {{
                  index > 1
                    ? getTimeToNextPOI(poi, itinerario.poi[index + 1])
                    : timeFromParkingToFirstPOI === 1
                    ? "1 minuto"
                    : timeFromParkingToFirstPOI + " minuti"
                }}</b
              >
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="vertical-line ml-2"></div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row"
        v-else-if="index > 0 && index < itinerario.poi.length - 2"
      >
        <div class="col-12 pl-4">
          <div class="vertical-line-same-poi ml-5"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const Common = require("@/Common.vue").default;

import $ from "jquery";
import store from "../../../store";
import { Button } from "element-ui";

import { config } from "../../../utils/config";

export default {
  name: "elenco-poi-md-lg",
  props: ["itinerario", "screenSize", "timeFromParkingToFirstPOI"],

  components: {
    Button,
  },

  data() {
    return {
      selectedTab: "Panoramica",
      windowWidth: 0,
      isLoadingImages: true,
      isLoadingVideos: true,
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      isMobile: false,
      isGeodidalab: false,

      numberOfActivityImagesRequest: 0,
      currentActivityImagesRequest: 0,
    };
  },
  created() {},

  methods: {
    getGroupName(poi) {
      return poi.poiName.replaceAll('"', "");
    },

    getGroupNameMarker(marker) {
      return marker.POItitle.replaceAll('"', "");
    },
    getTimeToNextPOI(poi, nextPOI) {
      var timesFromPOI = store.state.costMatricesTimeBetweenPOI.filter(
        (p) => parseInt(p["PoiID"]) === poi.poiID
      );

      var timeMillis = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000; //minuti di default di spostamento tra un poi e l'altro

      if (timesFromPOI[0]) {
        timeMillis = timesFromPOI[0][nextPOI.poiID];
      }

      if (timeMillis === "-1") {
        //se il tempo è -1 vuol dire che non è stato possibile calcolare il tempo di spostamento tra i due POI e usiamo quello di default
        timeMillis = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;
      }

      var timeMinutes = timeMillis / 60000;

      if (timeMinutes === 1) {
        return timeMinutes + " minuto";
      } else {
        return timeMinutes + " minuti";
      }
    },
    getSrc(poi) {
      var img = null;

      if (poi.media.length > 0) {
        if (poi.media[0].src === undefined) {
          //do nothing
        } else {
          var contextImages = null;
          var pathStr = "";

          if (!this.isLarge) {
            contextImages = require.context("../../../icons/large/", false, /\.png$/);
            pathStr = "./" + poi.media[0].src + "Large.png";
          } else {
            contextImages = require.context(
              "../../../icons/startPointImages/",
              false,
              /\.svg$/
            );
            pathStr = "./" + poi.media[0].src + ".svg";
          }

          img = contextImages(pathStr);
        }
        return poi.media[0].src === undefined
          ? poi.media[0]["thumbnail_display_urls"]["large"]
          : img;
      } else {
        return null;
      }
    },

    selectMarkerOnMap(poiName, activityName) {
      this.$emit("selectMarkerOnMap", poiName, activityName);
    },
    checkPoiAndNextPoiAreDifferent(poi, nextPOI) {
      return poi.poiID !== nextPOI.poiID;
    },
  },
  computed: {},
  
  mounted() {
  },
};
</script>

<style lang="scss">
.img {
  align-items: center;
  height: 100%;
  object-fit: cover;
  border-radius: 10px 10px 0px 0px;
}

.text {
  height: 15rem;
  overflow: scroll;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.card-body {
  padding: 0 !important;
}

.custom-image-slider {
  height: 270px !important;
}

.slider-indicator-icon {
  background-color: rgba(0, 0, 0, 0.458) !important;
}

.slider-indicator-active {
  background-color: white !important;
}
</style>